import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { OS_FAMILY_VIDEO_REPORT_ID } from './osFamilyVideoReportId';

const emptyColumns = [FIELDS.PLATFORM_CODE, FIELDS.OS_FAMILY].map(createFooterMapper(OS_FAMILY_VIDEO_REPORT_ID));

const osFamilyReportFooterColumnDefinition = [...emptyColumns];

export default osFamilyReportFooterColumnDefinition;
